// extracted by mini-css-extract-plugin
module.exports = {"imgWrapper":"brief-module--imgWrapper--55XjD","img":"brief-module--img--VRDUz"};